(function () {
  Controller.$inject = ['AppUtils'];

  window.angular.module('app').component('isoContainerDataDisplay', {
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      data: '<',
      onlyContent: '<',
      options: '<',
      disableClick: '<',
      onLoadContent: '=',
      maxHeight: '<',
      imageMode: '<',
      showHeader: '<',
      cssClass: '<',
    },
    template:'<div class="panel panel-default rt-panel rt-panel-sm {{ctrl.cssClass}}" ng-if="!ctrl.onlyContent"><header class="panel-heading" ng-if="ctrl.showHeader"><h2><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.image" data-html2canvas-ignore><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><button ng-click="ctrl.extendView = !ctrl.extendView" ng-disabled="!ctrl.imageLoaded" class="btn btn-default btn-xs"><i class="fas fa-external-link-alt"></i></button> <label ng-click="ctrl.viewMode = \'image\'" ng-class="{active: ctrl.viewMode === \'image\'}" class="btn btn-default btn-xs" title="Image"><input type="radio"> <i class="fas fa-image"></i></label> <label ng-click="ctrl.viewMode = \'raw\'" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-if="ctrl.content" class="full-height"><div ng-if="ctrl.viewMode=== \'image\'"><detection-iso-container-image sensor="ctrl.sensor" data="ctrl.data" image-mode="ctrl.imageMode" max-height="ctrl.maxHeight" disable-click="ctrl.disableClick" on-load-content="ctrl.onLoadImage"></detection-iso-container-image></div><div ng-if="ctrl.viewMode=== \'raw\'"><pre>{{ctrl.content | json}}</pre><div class="floating-btn" style="right: 5px" data-html2canvas-ignore><a class="btn btn-default btn-xs" ng-click="ctrl.downloadRawData()"><i class="fas fa-download fa-fw"></i></a></div></div></div><div ng-if="ctrl.data && !ctrl.data.content" class="not-data-found"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content" style="top: 0; bottom: 0; right: 0; left: 0"><div ng-if="ctrl.content"><div ng-if="ctrl.viewMode=== \'image\' && ctrl.image"><detection-iso-container-image sensor="ctrl.sensor" data="ctrl.data" image-mode="ctrl.imageMode" max-height="ctrl.maxHeight" disable-click="ctrl.disableClick" on-load-content="ctrl.onLoadContent"></detection-iso-container-image></div><div ng-if="ctrl.viewMode=== \'raw\'"><pre>{{ctrl.content | json}}</pre><div class="floating-btn" style="right: 5px" data-html2canvas-ignore><a class="btn btn-default btn-xs" ng-click="ctrl.downloadRawData()"><i class="fas fa-download fa-fw"></i></a></div></div></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div ng-if="ctrl.extendView" draggable class="floating-container floating-div"><div class="panel panel-default rt-panel rt-panel-md"><div class="panel-heading"><h2><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><i class="fas fa-fw fa-times" ng-click="ctrl.extendView = !ctrl.extendView"></i></div></div></div><div class="panel-body"><detection-iso-container-image sensor="ctrl.sensor" data="ctrl.data" max-height="ctrl.newImgWidth" disable-click="ctrl.disableClick" on-load-content="ctrl.onloadOverlay"></detection-iso-container-image><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div></div></div>',
  });

  function Controller(utils) {
    let vm = this;
    vm.viewMode = 'raw';

    vm.$onInit = function () {
      vm.extendView = false;
      vm.onLoadImage = onLoadImage;
      vm.downloadRawData = downloadRawData;
      vm.imageLoaded = false;

      vm.showHeader = typeof vm.showHeader === 'boolean' ? vm.showHeader : true;

      vm.windowSize = {
        width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
      };

      vm.windowSize.aspectRatio = vm.windowSize.width / vm.windowSize.height;

      getImage();
    };

    vm.$onChanges = function (changes) {
      if (!vm.data) {
        return;
      }

      vm.content = vm.data.content;
      getImage();
      vm.viewMode = vm.image ? 'image' : 'raw';
    };

    function getImage() {
      if (vm.content?.files) {
        vm.image = vm.content.files.image;
      } else {
        vm.image = null;
      }
    }

    function onLoadImage(error, img) {
      if (vm.onLoadContent) {
        vm.onLoadContent(error, img);
      }

      if (error || !img) {
        return;
      }

      vm.imageLoaded = img.src.indexOf('no-image.png') == -1;

      vm.imageNaturalSize = {
        width: img.naturalWidth,
        height: img.naturalHeight,
      };

      vm.imageNaturalSize.aspectRatio = vm.imageNaturalSize.width / vm.imageNaturalSize.height;

      let maxPerc = 0.7;
      vm.newImgWidth = vm.windowSize.width * maxPerc;
      vm.newImgHeight = vm.newImgWidth / vm.imageNaturalSize.aspectRatio;
    }

    function downloadRawData() {
      const data = vm.data.content;
      let ts = vm.data.from;
      if (ts.getTime) {
        ts = ts.getTime();
      }

      const sensorName = utils.removeAccents(vm.sensor.name).replace(/ /g, '_');
      const filename = sensorName + '_' + ts + '.json';
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'text/json;charset=utf-8' });

      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
})();
